import { useQuery } from "@tanstack/react-query";
import { priorityService } from "@/services/priorityService";

export type PriorityListParams = NonNullable<Parameters<typeof priorityService.getPriorities>[0]>;

/** Deliverables missing a DRI or a PPP. ponytail: capped at 100, paginate if the pool grows. */
export const CANDIDATE_LIST_PARAMS = { candidate: true, page: 1, limit: 100 } as const;

/** "No filter" has several spellings; collapse them so every caller hashes to the same query key. */
const pruneEmpty = (params: PriorityListParams): PriorityListParams => {
  const out: PriorityListParams = { ...params };
  for (const key of Object.keys(out) as (keyof PriorityListParams)[]) {
    const value = out[key];
    if (value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) delete out[key];
  }
  return out;
};

/** Takes the caller's list filters so a backlog never shows rows the ranked list above it excluded. */
export const useCandidates = (filters?: PriorityListParams) => {
  const params = { ...pruneEmpty(filters ?? {}), ...CANDIDATE_LIST_PARAMS };
  return useQuery({
    queryKey: ["priorities", "candidates", params],
    queryFn: () => priorityService.getPriorities(params),
  });
};
